import cmp from '../../lib/cmp';
import trackAppleWatchView from '../../lib/track-event/apple-watch-view';
import trackAppeleTVView from '../../lib/track-event/apple-tv-gallery-slide-view';
import { removeClass } from '../../lib/dom/className';
import { one } from '../../lib/dom/on';
import selectByClassName from '../../lib/dom/select-by-class';
import appleWatchSliderTracking from '../../lib/bind-event-tracking/apple-watch-gallery';
import appleTVSliderTracking from '../../lib/bind-event-tracking/apple-tv-gallery';

import smGallery from '../sm-landing-appstore-app-1-gallery/sm-landing-appstore-app-1-gallery';

import imageIMessage from '../../images/landing-appstore/offers-imessage';
import imageAppleWatch from '../../images/landing-appstore/offers-apple-watch';
import imageAppleTv from '../../images/landing-appstore/offers-apple-tv';
import imageIphone from '../../images/landing-appstore/offers-iphone';
import imageIpad from '../../images/landing-appstore/offers-ipad';
import './sm-landing-appstore-app-1-offers.less';
import { isRtl } from '../../lib/document-dir-utils';



const _appleWatchGalleryTracking = appleWatchSliderTracking();
const _appleTVSliderTracking = appleTVSliderTracking();

const HIDDEN_CLASS = 'sm-landing-appstore-app-1-offers--hide-screenshots';
const OPENER_CLASS = 'sm-landing-appstore-app-1-offers__opener';


const IPHONE_TARGET_TYPE = __('sm@_iphone');
const IPAD_TARGET_TYPE = __('sm@_ipad');

const IPHONE = 'iphone';
const IPAD = 'ipad';

const TARGET_TYPES_MAP = {
  [IPHONE]: IPHONE_TARGET_TYPE,
  [IPAD]: IPAD_TARGET_TYPE
};

const TARGET_ICONS_MAP = {
  [IPHONE]: `<div class="sm-landing-appstore-app-1-offers__badge">${imageIphone({ color: '#9d9da2' })}</div>`,
  [IPAD]: `<div class="sm-landing-appstore-app-1-offers__badge">${imageIpad({ color: '#9d9da2' })}</div>`
};


const iMessageBadge = `<div class="sm-landing-appstore-app-1-offers__badge">${imageIMessage({ color: '#9d9da2' })}</div>`;
const appleTVBadge = `<div class="sm-landing-appstore-app-1-offers__badge">${imageAppleTv({ color: '#9d9da2' })}</div>`;
const appleWatchBadge = `<div class="sm-landing-appstore-app-1-offers__badge">${imageAppleWatch({ color: '#9d9da2' })}</div>`;

const iMessageText = __('sm@_imessage');
const appleTVText = __('sm@_apple_tv');
const appleWatchText = __('sm@_apple_watch');

const offersIMessageText = __('sm@_offers_imessage_app');
const offersAppleTVText = __('sm@_offers_apple_tv_app');
const offersAppleWatchText = __('sm@_offers_apple_watch_app');

const offersTextMap = {
  [iMessageText]: offersIMessageText,
  [appleTVText]: offersAppleTVText,
  [appleWatchText]: offersAppleWatchText
};


const concatOffersPhrase = (arr) => {
  if (arr.length === 1) {
    return offersTextMap[arr[0]];
  }

  return arr.reduce((prev, cur, index) => {
    const length = arr.length;

    if (index === 0) {
      cur = (__('sm@_offers')).concat(' ', cur);
    }

    if (index === length - 1) {
      cur = cur.concat(' ', (length > 1 ? __('sm@_apps') : __('sm@_app')));
    }

    if (length > 1 && index === length - 1) {
      cur = ''.concat(' ', __('sm@_and'), ' ', cur);
    }

    if (length > 1 && index !== length - 1 && index !== 0) {
      cur = ''.concat(', ', cur);
    }

    return prev + cur;
  }, '');
};



export default cmp(
  null,
  ($cmp, { /*offers_ipad, */offersAppleTV, offersImessage, offersAppleWatch, appleWatch, appleTv, isIPAD }) => {
    const hasHiddenClass = (appleWatch && appleWatch.screenshots && offersAppleWatch) || (appleTv && appleTv.screenshots && offersAppleTV);

    const targetType = isIPAD ? IPAD : IPHONE;
    const targetDevice = TARGET_TYPES_MAP[targetType];
    const targetDeviceIcon = TARGET_ICONS_MAP[targetType];

    const hasAppleWatchScreenshots = appleWatch && appleWatch.screenshots && appleWatch.screenshots.length;
    const hasAppleTVScreenshots = appleTv && appleTv.screenshots && appleTv.screenshots.length;

    const offersArr = [
      offersImessage && iMessageText,
      offersAppleWatch && appleWatchText,
      offersAppleTV && appleTVText
    ].filter(Boolean);

    const offersPhraseTemplate = `
        <span class="sm-landing-appstore-app-1-offers__head-offers">
          ${concatOffersPhrase(offersArr)}
        </span>
    `;

    const getHeadArrowTemplate = (isRtlDirection = false) => {
      const headArrowClass = `sm-landing-appstore-app-1-offers__head-arrow${isRtlDirection ? '-rtl' : ''}`;
      const headArrowIpadClass = `${headArrowClass} sm-landing-appstore-app-1-offers__head-arrow--ipad${isRtlDirection ? '-rtl' : ''}`;

      if (hasAppleWatchScreenshots || hasAppleTVScreenshots) {
        return `
          <div class="${headArrowClass}"></div>
          <div class="${headArrowIpadClass}"></div>
        `;
      }

      return '';
    };

    const offersHead = `
      <div class="sm-landing-appstore-app-1-offers__head">
        ${isRtl() && targetDevice !== IPAD_TARGET_TYPE ? getHeadArrowTemplate(true) : ''}
        ${isRtl() ? offersPhraseTemplate : ''}
        ${offersImessage ? iMessageBadge : ''}
        ${offersAppleTV ? appleTVBadge : ''}
        ${offersAppleWatch ? appleWatchBadge : ''}
        ${!isRtl() ? offersPhraseTemplate : ''}
        <!-- TODO remove comment if need iPad offer
        {offers_ipad ? '<span class="sm-landing-appstore-app-1-offers__head-offer">iPad</span>' : ''}
          -->
        ${!isRtl() || targetDevice === IPAD_TARGET_TYPE ? getHeadArrowTemplate(isRtl()) : ''}
      </div>
    `;

    const getOffersDevice = (deviceData, label) => `
        <div class="sm-landing-appstore-app-1-offers__screenshots">
            ${$cmp('sm-landing-appstore-app-1-offers__gallery', smGallery, deviceData)}
        </div>
        <div class="sm-landing-appstore-app-1-offers__body-label">${label}</div>
        `;

    if (offersAppleWatch || offersAppleTV || offersImessage) {
      return `
        <div class="sm-landing-appstore-app-1-offers ${hasHiddenClass ? HIDDEN_CLASS : ''}">
          ${targetDevice && (hasAppleWatchScreenshots || hasAppleTVScreenshots) ? `<div class="${OPENER_CLASS}"></div>` : ''}
          <div class="sm-landing-appstore-app-1-offers__content">
            ${offersHead}

            <div class="sm-landing-appstore-app-1-offers__body">
              <div class="sm-landing-appstore-app-1-offers__body-label">
                ${targetDevice ? `<div class="sm-landing-appstore-app-1-offers__body-label-default">${isRtl() ? `${targetDevice}${targetDeviceIcon}` : `${targetDeviceIcon}${targetDevice}`}</div>` : ''}
              </div>

              ${offersAppleWatch && hasAppleWatchScreenshots ?
    getOffersDevice({
      screenshots: appleWatch.screenshots,
      video: null,
      galleryTracking: _appleWatchGalleryTracking,
      appleWatch: true
    }, isRtl() ? `${offersAppleWatchText}${appleWatchBadge}` : `${appleWatchBadge}${offersAppleWatchText}`)
    : ''}

              ${offersAppleTV && hasAppleTVScreenshots ?
    getOffersDevice({
      screenshots: appleTv.screenshots,
      galleryTracking: _appleTVSliderTracking,
      video: null
    }, isRtl() ? `${offersAppleTVText}${appleTVBadge}` : `${appleTVBadge}${offersAppleTVText}`)
    : ''}
            </div>
          </div>
        </div>
      `;
    }

    return targetDevice ? `<div class="sm-landing-appstore-app-1-offers__default">${targetDeviceIcon}${targetDevice}</div>` : '<span></span>';
  },
  (element, {
    appleTv,
    appleWatch
  }) => [
    one(selectByClassName(element, OPENER_CLASS), 'click', () => {
      removeClass(element, HIDDEN_CLASS);

      if (appleTv && appleTv.screenshots && appleTv.screenshots.length > 0) {
        trackAppeleTVView();
      }
      if (appleWatch && appleWatch.screenshots && appleWatch.screenshots.length > 0) {
        trackAppleWatchView();
      }
    })
  ]);



// WEBPACK FOOTER //
// ./src/landing-appstore-app-1/sm-landing-appstore-app-1-offers/sm-landing-appstore-app-1-offers.js